export const coreAdvantages = [
  {
    id: 'advantage-1',
    icon: 'ri-shield-check-line',
    title: '品质保证',
    description: 'clsq始终坚持严苛的质量标准，每款产品均经过多重检测流程，确保交付给客户的都是精品。我们以品质立身，用实力说话。',
  },
  {
    id: 'advantage-2',
    icon: 'ri-lightbulb-flash-line',
    title: '创新驱动',
    description: '持续投入研发资源，拥抱前沿技术，不断推出满足市场需求的创新产品。clsq的创新基因让我们始终走在行业前列。',
  },
  {
    id: 'advantage-3',
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '7x24小时全天候客户支持，专业团队随时待命。从售前咨询到售后保障，clsq提供一站式无忧服务体验。',
  },
  {
    id: 'advantage-4',
    icon: 'ri-team-line',
    title: '专业团队',
    description: '汇聚行业顶尖人才，核心团队平均从业经验超过10年。丰富的项目经验与深厚的专业功底，为您保驾护航。',
  },
  {
    id: 'advantage-5',
    icon: 'ri-price-tag-3-line',
    title: '高性价比',
    description: '优化供应链管理，降低运营成本，将实惠真正让利给客户。clsq始终坚持提供高性价比的优质产品与服务。',
  },
  {
    id: 'advantage-6',
    icon: 'ri-global-line',
    title: '广泛覆盖',
    description: '服务网络遍布全国主要城市，并持续拓展海外市场。无论您身在何处，clsq都能为您提供及时便捷的服务。',
  },
];

export const productServices = [
  {
    id: 'product-1',
    title: '智能解决方案',
    category: 'products',
    description: '基于AI技术的智能解决方案，帮助企业实现数字化转型，提升运营效率，降低人力成本，助力业务快速增长。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smart%20office%20with%20AI%20technology%20dashboard%20displays%2C%20clean%20minimalist%20design%2C%20warm%20ambient%20lighting%2C%20professional%20corporate%20atmosphere%2C%20futuristic%20yet%20warm%20aesthetic%2C%20soft%20cream%20background%20tones%2C%20elegant%20product%20photography&width=800&height=600&seq=clsq-product-01&orientation=landscape',
    features: ['AI智能分析', '实时数据监控', '自动化流程', '云端部署'],
  },
  {
    id: 'product-2',
    title: '企业管理系统',
    category: 'products',
    description: '一站式企业管理平台，覆盖财务、人事、项目、客户等核心业务模块，让企业管理更加高效、透明、规范。',
    image: 'https://readdy.ai/api/search-image?query=Enterprise%20management%20system%20interface%20on%20modern%20monitor%2C%20clean%20professional%20workspace%2C%20warm%20lighting%2C%20minimalist%20aesthetic%2C%20cream%20and%20warm%20gray%20background%2C%20elegant%20corporate%20photography&width=800&height=600&seq=clsq-product-02&orientation=landscape',
    features: ['财务管理', '人事管理', '项目管理', '客户关系'],
  },
  {
    id: 'product-3',
    title: '数据分析平台',
    category: 'products',
    description: '强大的数据分析工具，深度挖掘业务数据价值，提供可视化报表与智能洞察，为决策提供精准数据支持。',
    image: 'https://readdy.ai/api/search-image?query=Data%20analytics%20dashboard%20with%20colorful%20charts%20on%20screen%2C%20modern%20office%20setup%2C%20warm%20natural%20lighting%2C%20minimalist%20design%2C%20cream%20and%20warm%20tone%20background%2C%20professional%20business%20photography&width=800&height=600&seq=clsq-product-03&orientation=landscape',
    features: ['可视化报表', '智能洞察', '数据挖掘', '定制分析'],
  },
  {
    id: 'product-4',
    title: '云计算服务',
    category: 'solutions',
    description: '安全可靠的云计算基础设施服务，支持弹性扩展、高可用架构，为企业提供稳定高效的云端运行环境。',
    image: 'https://readdy.ai/api/search-image?query=Cloud%20computing%20server%20room%20with%20modern%20infrastructure%2C%20clean%20tech%20aesthetic%2C%20warm%20ambient%20lighting%2C%20professional%20atmosphere%2C%20cream%20and%20neutral%20background%2C%20elegant%20technology%20photography&width=800&height=600&seq=clsq-product-04&orientation=landscape',
    features: ['弹性扩展', '高可用架构', '安全防护', '7x24监控'],
  },
  {
    id: 'product-5',
    title: '安全解决方案',
    category: 'solutions',
    description: '全方位的网络安全防护方案，从威胁检测到应急响应，为企业的数字资产提供坚实的安全屏障。',
    image: 'https://readdy.ai/api/search-image?query=Cybersecurity%20concept%20with%20shield%20and%20digital%20network%2C%20modern%20clean%20design%2C%20warm%20minimalist%20aesthetic%2C%20cream%20background%2C%20professional%20corporate%20atmosphere%2C%20elegant%20tech%20photography&width=800&height=600&seq=clsq-product-05&orientation=landscape',
    features: ['威胁检测', '数据加密', '应急响应', '合规审计'],
  },
  {
    id: 'product-6',
    title: '技术咨询服务',
    category: 'support',
    description: '资深技术专家团队提供一对一咨询服务，涵盖架构设计、技术选型、性能优化等领域，助力企业技术升级。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20consulting%20meeting%20in%20modern%20office%2C%20warm%20natural%20light%2C%20minimalist%20design%2C%20cream%20and%20warm%20tones%2C%20elegant%20business%20atmosphere%2C%20harmonious%20composition&width=800&height=600&seq=clsq-product-06&orientation=landscape',
    features: ['架构设计', '技术选型', '性能优化', '培训赋能'],
  },
];

export const userReviews = [
  {
    id: 'review-1',
    name: '张伟',
    title: '某科技公司CEO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%2C%20warm%20lighting%2C%20minimalist%20cream%20background%2C%20friendly%20expression%2C%20corporate%20headshot%20style&width=120&height=120&seq=clsq-avatar-01&orientation=portrait',
    rating: 5,
    content: '与clsq合作已有三年，他们的产品和服务质量始终如一。智能解决方案帮助我们的运营效率提升了40%以上，是非常值得信赖的合作伙伴。',
  },
  {
    id: 'review-2',
    name: '李明华',
    title: '某金融集团CTO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businesswoman%20portrait%2C%20warm%20lighting%2C%20minimalist%20cream%20background%2C%20confident%20expression%2C%20corporate%20headshot%20style&width=120&height=120&seq=clsq-avatar-02&orientation=portrait',
    rating: 5,
    content: 'clsq的安全解决方案非常出色，帮助我们建立了一套完整的安全防护体系。技术团队专业负责，响应速度快，强烈推荐！',
  },
  {
    id: 'review-3',
    name: '王浩然',
    title: '某电商平台技术总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%2C%20warm%20lighting%2C%20minimalist%20cream%20background%2C%20friendly%20smile%2C%20corporate%20headshot%20style&width=120&height=120&seq=clsq-avatar-03&orientation=portrait',
    rating: 5,
    content: '数据分析和云计算服务让我们的业务上了一个新台阶。clsq不仅提供产品，更提供了完整的解决方案和持续的技术支持。',
  },
  {
    id: 'review-4',
    name: '陈思雨',
    title: '某制造企业CIO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businesswoman%20portrait%2C%20warm%20lighting%2C%20minimalist%20cream%20background%2C%20elegant%20expression%2C%20corporate%20headshot%20style&width=120&height=120&seq=clsq-avatar-04&orientation=portrait',
    rating: 4,
    content: '企业管理系统让我们的内部管理效率大幅提升，流程更加规范透明。clsq的服务团队非常用心，每次问题都能快速解决。',
  },
  {
    id: 'review-5',
    name: '赵鹏飞',
    title: '某教育集团技术负责人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%2C%20warm%20lighting%2C%20minimalist%20cream%20background%2C%20approachable%20expression%2C%20corporate%20headshot%20style&width=120&height=120&seq=clsq-avatar-05&orientation=portrait',
    rating: 5,
    content: '从第一次接触到完成部署，clsq团队展现出了极高的专业水准。技术咨询服务帮助我们规避了很多潜在风险，是真正的行业专家。',
  },
];

export const faqList = [
  {
    id: 'faq-1',
    question: 'clsq是什么品牌？',
    answer: 'clsq是一家专注于智能解决方案与企业服务的科技品牌，致力于为各行业客户提供高品质的产品、解决方案和专业服务。我们以创新驱动发展，以诚信为本，已经服务了超过500家企业客户，覆盖金融、制造、教育、电商等多个领域。',
  },
  {
    id: 'faq-2',
    question: 'clsq的产品主要服务哪些行业？',
    answer: 'clsq的产品和解决方案广泛应用于金融、制造、教育、电商、医疗等多个行业。我们根据各行业的独特需求提供定制化服务，确保产品能够真正解决客户的实际问题，助力企业实现数字化转型。',
  },
  {
    id: 'faq-3',
    question: '如何获取clsq的产品报价？',
    answer: '您可以通过官网的联系我们页面提交需求表单，我们的销售团队会在24小时内与您取得联系，根据您的具体需求提供个性化的产品方案和报价。也欢迎直接拨打我们的客服热线进行咨询。',
  },
  {
    id: 'faq-4',
    question: 'clsq是否提供免费试用？',
    answer: '是的，我们为大多数产品提供14天的免费试用期。在试用期间，您可以完整体验产品的全部功能，并且有专属的技术顾问全程指导，帮助您充分了解产品价值。试用结束后，您可以根据实际情况选择是否继续使用。',
  },
  {
    id: 'faq-5',
    question: 'clsq的售后服务如何？',
    answer: '我们提供7x24小时全天候售后服务，包括在线客服、电话支持、远程协助等多种方式。同时，每位客户都会配备专属的客户成功经理，定期回访了解使用情况，确保产品持续稳定运行。',
  },
  {
    id: 'faq-6',
    question: 'clsq的数据安全保障措施有哪些？',
    answer: 'clsq采用业界领先的安全技术，包括数据加密传输、多重身份认证、定期安全审计等措施。我们已通过ISO 27001信息安全管理体系认证，所有数据存储均符合国家相关法律法规要求，全方位保障客户数据安全。',
  },
  {
    id: 'faq-7',
    question: 'clsq的产品是否支持定制化开发？',
    answer: '支持。我们拥有强大的研发团队，可以根据客户的特定需求进行功能定制和二次开发。无论是界面定制、流程优化还是系统集成，clsq都能提供灵活高效的定制化服务，确保产品完美匹配您的业务场景。',
  },
];

export const articles = [
  {
    slug: 'clsq-introduction',
    title: 'clsq品牌全面解读：创新驱动，品质为本',
    summary: '深入了解clsq品牌的发展历程、核心价值与未来愿景，探索我们如何通过持续创新与卓越品质赢得市场信赖。',
    content: `<p>clsq自创立以来，始终秉持"创新驱动、品质为本"的核心理念，致力于为客户提供卓越的产品与服务。</p>
<p>在数字化转型的浪潮中，clsq敏锐洞察市场趋势，持续加大研发投入，组建了一支由行业顶尖人才构成的技术团队。我们深知，只有不断创新，才能在激烈的市场竞争中保持领先地位。</p>
<p>品质是clsq的生命线。从原材料采购到产品交付，每一个环节都严格执行质量管理标准。我们建立了完善的质量检测体系，确保每一件产品都经得起市场的检验。</p>
<p>展望未来，clsq将继续深耕智能科技领域，以更高的标准要求自己，为更多客户创造实实在在的价值。</p>`,
    category: '品牌故事',
    date: '2026-07-15',
    readTime: '5分钟',
  },
  {
    slug: 'clsq-products',
    title: 'clsq核心产品线详解：一站式企业解决方案',
    summary: '全面了解clsq六大核心产品线的功能特性与应用场景，找到最适合您企业的数字化转型方案。',
    content: `<p>clsq构建了完善的产品矩阵，涵盖智能解决方案、企业管理系统、数据分析平台、云计算服务、安全解决方案和技术咨询服务六大板块。</p>
<p>智能解决方案基于前沿AI技术，帮助企业实现业务流程的智能化升级；企业管理系统整合了财务、人事、项目等核心模块，让管理更加高效透明；数据分析平台为企业提供深度数据洞察，赋能精准决策。</p>
<p>云计算服务保障业务稳定运行，安全解决方案为企业数字资产筑牢防线，技术咨询服务则为企业提供从规划到落地的全程支持。</p>
<p>每一款产品都经过精心打磨，力求为客户创造最大价值。</p>`,
    category: '产品动态',
    date: '2026-07-20',
    readTime: '8分钟',
  },
  {
    slug: 'clsq-cases',
    title: 'clsq成功案例精选：见证品牌实力',
    summary: '通过多个行业标杆案例，展示clsq如何帮助客户实现业务增长与效率提升，用事实诠释品牌价值。',
    content: `<p>在过去几年中，clsq服务了超过500家企业客户，积累了丰富的行业经验。以下是部分成功案例的展示。</p>
<p>某大型金融机构通过部署clsq的智能风控解决方案，将风险识别准确率提升了65%，同时大幅降低了人工审核成本。该方案已成为行业内的标杆实践。</p>
<p>一家知名电商平台采用clsq的数据分析平台后，用户转化率提升了30%，运营效率显著提高。平台技术总监表示："clsq不仅仅是一个产品供应商，更是我们数字化转型道路上的战略伙伴。"</p>
<p>这些案例只是clsq服务能力的一个缩影，我们期待与更多客户携手创造价值。</p>`,
    category: '客户案例',
    date: '2026-07-25',
    readTime: '6分钟',
  },
  {
    slug: 'clsq-technology',
    title: 'clsq技术实力深度剖析：持续创新的源动力',
    summary: '揭秘clsq背后的核心技术体系与研发实力，了解我们如何通过技术创新保持行业领先地位。',
    content: `<p>技术是clsq的核心竞争力。我们建立了完善的技术研发体系，持续投入前沿技术研究。</p>
<p>在人工智能领域，clsq自主研发了多项核心算法，在自然语言处理、计算机视觉等方向取得了突破性进展。我们的AI模型在多个公开评测中表现优异。</p>
<p>在云计算与大数据方面，clsq构建了高可用、弹性扩展的技术架构，支撑了海量数据的实时处理与分析。安全技术方面，我们拥有多项自主知识产权，形成了完整的安全防护体系。</p>
<p>技术创新永无止境，clsq将继续加大研发投入，以技术引领未来。</p>`,
    category: '技术前沿',
    date: '2026-07-30',
    readTime: '7分钟',
  },
  {
    slug: 'privacy',
    title: '隐私政策',
    summary: 'clsq高度重视用户隐私保护，本政策详细说明了我们如何收集、使用和保护您的个人信息。',
    content: `<p>clsq（以下简称"我们"）深知个人信息对您的重要性，我们将按照法律法规的规定，保护您的个人信息安全。</p>
<p>我们仅在为您提供服务所必需的范围内收集您的个人信息，且不会将这些信息用于本政策未明示的其他用途。</p>
<p>我们采取了严格的安全措施来保护您的个人信息，包括但不限于数据加密、访问控制、安全审计等。</p>
<p>如您对本隐私政策有任何疑问，请通过官方渠道与我们联系。</p>`,
    category: '法律政策',
    date: '2026-08-01',
    readTime: '10分钟',
  },
  {
    slug: 'terms',
    title: '服务条款',
    summary: '使用clsq产品和服务前，请仔细阅读本服务条款，了解您的权利与义务。',
    content: `<p>欢迎使用clsq的产品和服务。本服务条款（以下简称"条款"）是您与clsq之间关于使用我们产品和服务所订立的协议。</p>
<p>使用我们的服务即表示您同意接受本条款的约束。如果您不同意本条款的任何内容，请不要使用我们的服务。</p>
<p>我们保留随时修改本条款的权利，修改后的条款将在公布后生效。建议您定期查阅本条款的更新内容。</p>`,
    category: '法律政策',
    date: '2026-08-01',
    readTime: '12分钟',
  },
];

export const categories = [
  { id: 'products', label: '核心产品', icon: 'ri-stack-line' },
  { id: 'solutions', label: '解决方案', icon: 'ri-lightbulb-line' },
  { id: 'support', label: '技术支持', icon: 'ri-tools-line' },
];